import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Salje GA4 "page_view" na svaku navigaciju u SPA-u.
 *
 * Consent Mode v2: gtag je ucitan sa podrazumevanim "denied" consent-om,
 * pa se pre opt-in-a salju samo cookieless pingovi (agregatno modeliranje).
 * Posle prihvatanja analytics kolacica, isti poziv koristi puni tracking.
 */
const GoogleAnalyticsPageViewComponent: FC = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (typeof window.gtag !== 'function') return;

        window.gtag('event', 'page_view', {
            page_path: pathname + search,
            page_location: window.location.href,
        });
    }, [pathname, search]);

    return null;
};

export default GoogleAnalyticsPageViewComponent;
